import { EMPTY_QUILL_HTML } from "../lib/richTextEditor";

/** Labels shown when rejecting an applicant (role manage modal). */
export const APPLICANT_REJECT_REASONS = [
  "No reason",
  "Lack of required experience or experience mismatch",
  "Skills mismatch",
  "Salary expectations mismatch",
  "Role location mismatch",
];

function slugId(label) {
  return `builtin-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`;
}

/** Placeholder copy until final templates are provided. */
const DEFAULT_RESPONSE_BY_LABEL = {
  "No reason":
    "<p>Thank you for your interest in this role and for the time you put into your application. After careful consideration, we will not be moving forward with your application at this time.</p>",
  "Lack of required experience or experience mismatch":
    "<p>Thank you for applying. We have reviewed your experience against the requirements for this role and, on this occasion, we do not feel there is a close enough match to progress your application further.</p>",
  "Skills mismatch":
    "<p>Thank you for your application. Based on the skills needed for this position, we will not be progressing your candidacy. We encourage you to explore other roles that may be a stronger fit for your strengths.</p>",
  "Salary expectations mismatch":
    "<p>Thank you for your interest. Following our review, we are unable to align on compensation expectations for this role, so we will not be moving your application forward.</p>",
  "Role location mismatch":
    "<p>Thank you for applying. This role has specific location requirements that we could not align with your application, so we will not be progressing you to the next stage.</p>",
};

/**
 * @returns {{ id: string, label: string, isCustom: boolean, responseHtml: string }[]}
 */
export function createDefaultRejectionReasonTemplates() {
  return APPLICANT_REJECT_REASONS.map((label) => ({
    id: slugId(label),
    label,
    isCustom: false,
    responseHtml: DEFAULT_RESPONSE_BY_LABEL[label] || EMPTY_QUILL_HTML,
  }));
}

export function createCustomRejectionReasonTemplate() {
  return {
    id: `custom-${crypto.randomUUID()}`,
    label: "",
    isCustom: true,
    responseHtml: EMPTY_QUILL_HTML,
  };
}

const BUILTIN_REJECTION_TEMPLATE_IDS = createDefaultRejectionReasonTemplates().map((t) => t.id);

/** Stable list order: built-in reasons (by default id), then custom reasons. */
export function sortRejectionReasonTemplates(templates) {
  const byId = new Map(templates.map((t) => [t.id, t]));
  const ordered = [];

  for (const id of BUILTIN_REJECTION_TEMPLATE_IDS) {
    const row = byId.get(id);
    if (row) ordered.push(row);
  }

  for (const row of templates) {
    if (row.isCustom && !ordered.includes(row)) ordered.push(row);
  }

  return ordered;
}
